(() => {
  let version = 0;
  document.addEventListener('cart:update', async () => {
    const current = ++version;
    const counters = [...document.querySelectorAll('[data-eco-cart-count]')];
    if (!counters.length) return;
    try {
      const response = await fetch(counters[0].dataset.cartStateUrl, {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid count');
      if (current === version) counters.forEach(el => {el.textContent=String(cart.item_count);});
    } catch {
      if (current === version) counters.forEach(el => {el.textContent='—';});
    }
  });
})();
